import React from 'react';
import { Moon, Sun } from 'lucide-react';
import '../styles/ThemeToggle.css';

function ThemeToggle({ isDark, onChange }) {
  return (
    <button
      className="theme-toggle-btn"
      onClick={() => onChange(!isDark)}
      aria-label="Toggle Theme"
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}

export default ThemeToggle;
